import { getTechnologyNames } from "@helpers/technology";

export const TechnologyNames = ({ serviceIds = [] }) => {
  const names = getTechnologyNames(serviceIds);

  return <span>{names.join(", ")}</span>;
};
